var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7914.83,-839.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "friends-2-lines",
    transform: "matrix(0.541992,0,0,0.948765,3661.26,157.428)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7848.05,
    y: 718.398,
    width: 59.042,
    height: 33.728,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.45024,0,0,0.832167,-2956.61,270.531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7470.65,548.028L7470.64,548.028L7470.6,548.028L7470.57,548.028L7470.49,548.028L7470.49,548.028L7470.48,548.028C7470.44,548.029 7470.39,548.033 7470.35,548.041C7469.42,548.106 7468.18,548.437 7467.27,549.401C7466.58,550.135 7466.06,551.239 7466.07,552.913L7466.07,552.937C7466.09,554.725 7467.02,555.975 7468.22,556.785C7466.29,557.491 7464.37,558.612 7462.98,560.532C7461.72,562.269 7460.87,564.669 7460.87,568.046C7460.87,568.512 7461.25,568.89 7461.72,568.89C7462.19,568.89 7462.57,568.512 7462.57,568.046C7462.57,565.118 7463.26,563.026 7464.35,561.52C7465.97,559.29 7468.44,558.361 7470.63,557.821C7472.82,558.361 7475.28,559.29 7476.9,561.52C7477.99,563.026 7478.69,565.118 7478.69,568.046C7478.69,568.512 7479.07,568.89 7479.53,568.89C7480,568.89 7480.38,568.512 7480.38,568.046C7480.38,564.669 7479.54,562.269 7478.28,560.532C7476.89,558.612 7474.97,557.491 7473.04,556.785C7474.23,555.975 7475.17,554.725 7475.19,552.937L7475.19,552.937C7475.21,551.249 7474.68,550.138 7473.99,549.401C7473.08,548.437 7471.83,548.106 7470.91,548.041C7470.87,548.033 7470.82,548.029 7470.78,548.028C7470.73,548.028 7470.69,548.028 7470.65,548.028ZM7470.63,549.717C7470.03,549.728 7469.14,549.889 7468.51,550.557C7468.05,551.046 7467.75,551.8 7467.76,552.92L7467.76,552.92C7467.78,554.749 7469.29,555.671 7470.63,556.072C7471.96,555.672 7473.47,554.752 7473.49,552.929L7473.49,552.92C7473.5,551.8 7473.21,551.046 7472.75,550.557C7472.12,549.889 7471.23,549.728 7470.63,549.717Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.81616,0,0,1.0375,2664.81,153.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2870.22,547.743C2863.12,547.743 2857.35,553.509 2857.35,560.611C2857.35,567.714 2863.12,573.48 2870.22,573.48C2877.32,573.48 2883.09,567.714 2883.09,560.611C2883.09,553.509 2877.32,547.743 2870.22,547.743ZM2870.22,549.098C2876.58,549.098 2881.73,554.257 2881.73,560.611C2881.73,566.966 2876.58,572.125 2870.22,572.125C2863.87,572.125 2858.71,566.966 2858.71,560.611C2858.71,554.257 2863.87,549.098 2870.22,549.098Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.ab56b93bb40c4877b0c84f5a91d400df.svg";
export { ForwardRef as ReactComponent };